import React from "react";
import useSWR from "swr";
import groq from "groq";
import sanityClient from "../../../data/sanityClient";

import EntryCardLarge from "../../EntryCardLarge";
import AuthContext from "../../../context/AuthContext";

type Props = {
  id: string;
  onClose: () => void;
};

export const EntryDialog: React.FC<Props> = ({ id, onClose }) => {
  const { state, addLike, removeLike } = React.useContext(AuthContext);

  const { data, mutate } = useSWR(
    groq`*[_type == "entry" && _id == "${id}"] {
    ...,
    "user": user-> {
      ...
    },
    "category": category-> {
      ...
    }
  }`,
    (query) => sanityClient.fetch(query)
  );

  const handleLike = async (postId: string) => {
    const variables = {
      id: postId,
    };

    // Post to sanity proxy api
    try {
      const response = await fetch("/api/like", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(variables),
      });

      if (!response.ok) {
        throw new Error("Kunne ikke legge til like");
      } else {
        addLike(postId);
        mutate();
      }
    } catch (error) {
      alert(error);
    }
  };

  const handleUnlike = async (postId: string) => {
    const variables = {
      id: postId,
    };

    // Post to sanity proxy api
    try {
      const response = await fetch("/api/unlike", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(variables),
      });

      if (!response.ok) {
        throw new Error("Kunne ikke fjerne like");
      } else {
        removeLike(postId);
        mutate();
      }
    } catch (error) {
      alert(error);
    }
  };

  return (
    <>
      <EntryCardLarge
        title={data?.[0]?.title}
        userName={data?.[0]?.user.name}
        description={data?.[0]?.description}
        category={data?.[0]?.category.title}
        likes={data?.[0]?.likes}
        imageUrl={data?.[0]?.imageUrl}
        hasLiked={state?.userLikes?.includes(data?.[0]?._id)}
        onLike={() => handleLike(data?.[0]?._id)}
        onUnlike={() => handleUnlike(data?.[0]?._id)}
        onClose={onClose}
      />
    </>
  );
};
